module.exports = __webpack_public_path__ + "static/isabella_carmone-7547f9cf0985c487a3c424acacf9270b.jpeg";